module.exports = __webpack_public_path__ + "static/media/pivx.782df35d.svg";